import {Directive, ElementRef, HostListener, OnDestroy, OnInit, Renderer2} from '@angular/core';

@Directive({
  selector: '[stick]',
  standalone: true,
})
export class HeroStickDirective implements OnInit, OnDestroy {

  private static zIndexCounter = 1000;

  private originalPosition: number = 0;
  private isSticky: boolean = false;
  private placeholder: HTMLElement | null = null;
  private zIndex: number;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {
    this.zIndex = HeroStickDirective.zIndexCounter++;
  }

  ngOnInit() {
    // Store the original top position of the element
    this.originalPosition = this.el.nativeElement.getBoundingClientRect().top + window.scrollY;
    this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
    this.renderer.setStyle(this.el.nativeElement, 'zIndex', this.zIndex.toString());
  }

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    const currentScroll = window.scrollY;
    const elementRect = this.el.nativeElement.getBoundingClientRect();

    // Check if element has reached the top of viewport
    if (!this.isSticky && elementRect.top <= 0 && currentScroll >= this.originalPosition) {
      this.makeSticky();
    }
    // Check if scrolled back to original position
    else if (this.isSticky && currentScroll <= this.originalPosition) {
      this.removeSticky();
    }
  }

  private makeSticky() {
    this.isSticky = true;

    // Create placeholder to maintain layout
    this.placeholder = this.renderer.createElement('div');
    this.renderer.setStyle(this.placeholder, 'height', `${this.el.nativeElement.offsetHeight}px`);
    this.renderer.insertBefore(
      this.el.nativeElement.parentNode,
      this.placeholder,
      this.el.nativeElement
    );

    // Apply sticky styles
    this.renderer.setStyle(this.el.nativeElement, 'position', 'fixed');
    this.renderer.setStyle(this.el.nativeElement, 'top', '0');
    this.renderer.setStyle(this.el.nativeElement, 'left', '0.75rem');
    this.renderer.setStyle(this.el.nativeElement, 'right', '0.75rem');
    this.renderer.setStyle(this.el.nativeElement, 'zIndex', '1000');
  }

  private removeSticky() {
    this.isSticky = false;

    // Remove sticky styles
    this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
    this.renderer.removeStyle(this.el.nativeElement, 'top');
    this.renderer.removeStyle(this.el.nativeElement, 'left');
    this.renderer.removeStyle(this.el.nativeElement, 'right');


    // Remove placeholder
    if (this.placeholder) {
      this.renderer.removeChild(this.el.nativeElement.parentNode, this.placeholder);
      this.placeholder = null;
    }
  }

  ngOnDestroy() {
    // Cleanup
    if (this.placeholder) {
      this.renderer.removeChild(this.el.nativeElement.parentNode, this.placeholder);
    }
  }

}
